import * as types from "./types";
import Routes from "../../api/routes"; // API endpoint routes
import { get, getForSSR, getForWithoutHeader } from "../../api";
import { page_limit } from "utils";
const {
  BRAND_CATEGORY_BANNER_DETAILS,
  BRAND_CATEGORY_VEHICLE_DATA,
  GET_BRAND_INFO,
} = Routes;

/******************* 
@purpose :  get brand banner data
@Parameter : {}
@Author : INIC
******************/
export const getBrandBannerData = (locationId, slug) => (dispatch) => {
  return getForWithoutHeader(
    `${BRAND_CATEGORY_BANNER_DETAILS}?location_id=${locationId}&brand_slug=${slug}`,
    false
  ).then((res) => {
    if (res?.data) {
      dispatch(setBrandBannerData(res?.data));
      return Promise.resolve(res.data);
    }
    return Promise.reject(res);
  });
};

/******************** 
@purpose : set brand banner data
@Parameter : { data }
@Author : INIC
******************/
export const setBrandBannerData = (data) => {
  return {
    type: types.SET_BRAND_BANNER_INFO,
    data,
  };
};

/******************* 
@purpose :  get brand banner data
@Parameter : {}
@Author : INIC
******************/
export const getBrandVehicleData =
  (locationId, slug, authorizationToken) => (dispatch) => {
    let fullUrl = "";

    if (authorizationToken) {
      fullUrl = getForSSR(
        `${BRAND_CATEGORY_VEHICLE_DATA}?location_id=${locationId}&brand_slug=${slug}&page_limit=${page_limit}`,
        false,
        false,
        authorizationToken
      );
    } else {
      fullUrl = getForWithoutHeader(
        `${BRAND_CATEGORY_VEHICLE_DATA}?location_id=${locationId}&brand_slug=${slug}&page_limit=${page_limit}`,
        false
      );
    }

    return fullUrl.then((res) => {
      if (res?.data) {
        return Promise.resolve(res);
      }
      return Promise.reject(res);
    });
  };

/******************* 
@purpose :  get brand information
@Parameter : {}
@Author : INIC
******************/
export const getBrandInfo =
  (locationId, id, loader = true) =>
  (dispatch) => {
    return get(
      `${GET_BRAND_INFO}/${id}?location_id=${locationId}`,
      false,
      loader
    ).then((res) => {
      if (res?.statusCode == 200) {
        return Promise.resolve(res.data);
      }
      return Promise.reject(res);
    });
  };
